// extracted by mini-css-extract-plugin
var _1 = "OEcMX";
var _2 = "GheQW";
export { _1 as "fieldset", _2 as "radio" }
